import {CustomFindStoresAction, FIND_STORES_SUCCESS} from "../actions/custom-store-finder.actions";
import {CustomFindStoresState} from "../selectors/custom-store-finder.states";

export const initialState: CustomFindStoresState = {
  findStoresEntities: {},
};

export function customFindStoresReducer(
  state = initialState,
  action: CustomFindStoresAction
): CustomFindStoresState {
  switch (action.type) {
    case FIND_STORES_SUCCESS: {
      const findStoresEntities = action.payload;

      return { ...state, findStoresEntities };
    }
  }

  return state;
}
